// Class containing all API calls specifications
import axios from "axios"

const host = window.location.host;

const baseResourceURL = host === "www.mytravo.net" || host === 'mytravo.net' ? "https://api.mytravo.net" :  "https://api.beta.mytravo.net" // https://api.beta.mytravo.net
const baseApiURL = host === "www.mytravo.net" || host === 'mytravo.net' ? "https://api.mytravo.net/v2" : "https://api.beta.mytravo.net/v2"
const POST = "POST"
const GET = "GET"
const POST_FORM = "POST-FORM"

export const requestBuilder = (url, method, data, token) => {
  if (method === GET) {
    if (token) {
      return axios.get(url, {
        headers: { Authorization: "Bearer " + token }
      })
    } else {
      return axios.get(url)
    }
  } else if (method === POST) {
    if (token) {
      return axios.post(url, data, {
        headers: { Authorization: "Bearer " + token }
      })
    } else {
      return axios.post(url, data)
    }
  } else if (method === POST_FORM) {
    if (token) {
      return axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data"
        }
      })
    } else {
      return axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    }
  } else {
    // We'll see if we need to handle more cases in the future.
  }
}

const api = {
  resourceURL: baseResourceURL,
  apiURL: baseApiURL,
  getUser: token => {
    return requestBuilder(baseApiURL + "/user/get", GET, undefined, token)
  },
  updateUser: (token, userForm) => {
    return requestBuilder(
      baseApiURL + "/user/update",
      POST_FORM,
      userForm,
      token
    )
  },
  login: loginForm => {
    return requestBuilder(
      baseApiURL + "/login",
      POST_FORM,
      loginForm,
      undefined
    )
  },
  register: (token, registerData) => {
    var inlinedData = JSON.stringify(registerData)
    return requestBuilder(
      baseApiURL + "/register/info/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  getCountries: (token, langData) => {
    var inlinedData = JSON.stringify(langData)
    return requestBuilder(
      baseApiURL + "/countries/info/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  changePass: (token, changePassData) => {
    var inlinedData = JSON.stringify(changePassData)
    return requestBuilder(
      baseApiURL + "/changepass/info/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  resetPassword: resetData => {
    var inlinedData = JSON.stringify(resetData)
    return requestBuilder(
      baseApiURL + "/reset/info/" + inlinedData,
      GET,
      undefined,
      undefined
    )
  },
  getEnv: (token, envData) => {
    var inlinedData = JSON.stringify(envData)
    return requestBuilder(
      baseApiURL + "/environment/info/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  getConfigFile: configFileUrl => {
    return requestBuilder(configFileUrl, GET, undefined, undefined)
  },
  sendMail: (token, mailForm) => {
    return requestBuilder(
      baseApiURL + "/newsletter",
      POST_FORM,
      mailForm,
      token
    )
  },
  createSub: (token, subForm) => {
    return requestBuilder(baseApiURL + "/sub/create", POST_FORM, subForm, token)
  },
  getAllSub: token => {
    return requestBuilder(baseApiURL + "/sub/getall", GET, undefined, token)
  },
  getSub: (token, subData) => {
    var inlinedData = JSON.stringify(subData)
    return requestBuilder(
      baseApiURL + "/sub/get/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // CRUD List
  createList: (token, listData) => {
    var inlinedData = JSON.stringify(listData)
    return requestBuilder(
      baseApiURL + "/list/create/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // Read
  getList: (token, listData) => {
    var inlinedData = JSON.stringify(listData)
    return requestBuilder(
      baseApiURL + "/list/get/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // Update
  updateList: (token, listData) => {
    var inlinedData = JSON.stringify(listData)
    return requestBuilder(
      baseApiURL + "/list/update/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // Delete
  deleteList: (token, listData) => {
    var inlinedData = JSON.stringify(listData)
    return requestBuilder(
      baseApiURL + "/list/delete/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // CRUD Article List
  createManualUserArticle: (token, articleForm) => {
    return requestBuilder(
      baseApiURL + "/list-article/create-user-manual",
      POST_FORM,
      articleForm,
      token
    )
  },
  createManualArticle: (token, articleForm) => {
    return requestBuilder(
      baseApiURL + "/list-article/create-manual",
      POST_FORM,
      articleForm,
      token
    )
  },
  // Read
  getArticleList: (token, articleListData) => {
    var inlinedData = JSON.stringify(articleListData)
    return requestBuilder(
      baseApiURL + "/list-article/get/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // Update
  updateArticleList: (token, updateForm) => {
    return requestBuilder(
      baseApiURL + "/list-article/update",
      POST_FORM,
      updateForm,
      token
    )
  },
  // Delete
  deleteArticleList: (token, articleListData) => {
    var inlinedData = JSON.stringify(articleListData)
    return requestBuilder(
      baseApiURL + "/list-article/delete/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // CRUD Group article
  createGroupArticle: (token, groupArticleData) => {
    var inlinedData = JSON.stringify(groupArticleData)
    return requestBuilder(
      baseApiURL + "/list-article/create-ga/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // Read
  getGroupArticle: (token, groupArticleData) => {
    var inlinedData = JSON.stringify(groupArticleData)
    return requestBuilder(
      baseApiURL + "/grouparticle/search/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  findGroupArticleById: (token, groupArticleData) => {
    var inlinedData = JSON.stringify(groupArticleData)
    return requestBuilder(
      baseApiURL + "/grouparticle/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // CRUD Article
  createArticle: (token, articleData) => {
    var inlinedData = JSON.stringify(articleData)
    return requestBuilder(
      baseApiURL + "/list-article/create-a/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  findArticle: (token, articleData) => {
    var inlinedData = JSON.stringify(articleData)
    return requestBuilder(
      baseApiURL + "/article/search/" + inlinedData,
      GET,
      undefined,
      token
    )
  },
  // Historic
  createHisto: (token, histoForm) => {
    return requestBuilder(
      baseApiURL + "/calchisto/create",
      POST_FORM,
      histoForm,
      token
    )
  },
  getAllHisto: (token, histoData) => {
    var inlinedData = JSON.stringify(histoData)
    return requestBuilder(
      baseApiURL + "/calchisto/getall/" + inlinedData,
      POST,
      undefined,
      token
    )
  }
}
export default api



// WEBPACK FOOTER //
// ./src/services/api.js